import React from "react";
import { getFormattedPrice } from "../../reducers/global";
const withCurrency = (currency, content, className) => {
  const price = getFormattedPrice(currency.key, content);
  return <div className={className}>{price}</div>;
};

export default withCurrency;
